module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“Tell me one good reason. why you and I can’t continue to be lovers.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Fury ignited along her veins. Sex! Was that all he ever wanted from her? Was that all he ever wanted from any woman whom he didn’t rate as a perfect ten?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“Very well,” she bit out. “I’ll give you one very good reason. Soon, you won’t want me as your lover. Soon, that wonderful chemistry you spoke of will fail to spark, because I’ll be too big and fat to inspire much in you except revulsion. Yes, Lewis, I see the penny’s beginning to drop. Yes, that’s right. I’m going to have a baby!”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6105d89a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459252165_fm01.vue
// module id = 60
// module chunks = 0